import React, { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { HeadlineLarge } from '@shared/ui/atoms/fonts/Headline';
import { selectCurrentUser } from '@shared/store/auth.duck';
import { GoBackButton } from '@shared/ui/atoms/buttons/GoBackButton';
import { isCompanyAdminUser } from "@shared/utils/AccessControl";
import AccessRequired from "../components/AccessRequired";
import { useTranslation } from "react-i18next";
import { selectAllDepartments } from "@features/whereabouts/pages/departments/data/departments.duck";
import { PrimaryButton } from '@shared/ui/atoms/buttons/PrimaryButton';
import { Department } from "../../../departments/data/departments.models";
import { DepartmentContentCard } from "./components/DepartmentContentCard";
import { DialogIdentifiers, openDialogWithPayload } from "@shared/store/dialog.duck";
import { ButtonSize } from '@shared/ui/atoms/buttons/ButtonStyling';

export default function ManageDepartmentsPage() {
  const dispatch = useDispatch();
  const current = useSelector(selectCurrentUser);
  const company = current?.companyEntity;
  const departments = useSelector(selectAllDepartments);
  const hasAccessToManageDepartments = useMemo(() => isCompanyAdminUser(current), [current]);
  const {t} = useTranslation();

  const addNewDepartment = () => {
    dispatch(openDialogWithPayload({
      payload: { },
      activeDialog: DialogIdentifiers.EditDepartmentDialog
    }))
  }

  return (
    <>
      <GoBackButton url={'/manage'} />
      <HeadlineLarge className="teamList__header">{t('settings.departments.title')}</HeadlineLarge>
      <div className="manage__sections">

        <AccessRequired visible={!hasAccessToManageDepartments} companyAdminsRequired={true} />

          {departments.map((department: Department) => (<DepartmentContentCard department={department} />))}

      </div>
      {company?.enabled && <PrimaryButton size={ButtonSize.Medium}
                                          fullWidth={true}
                                          click={addNewDepartment}
                                          text={'settings.departments.add-new'} />}
    </>
  );
}
